import React from 'react';
import './Hero.css';

const ArrowIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M3 8H13M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const capabilities = [
  {
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M2 12l4-4 3 3 5-7" /></svg>,
    title: 'Business Strategy',
    desc: 'Growth roadmaps, market penetration & model creation',
  },
  {
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="8" cy="8" r="6" /><path d="M8 5v3l2 2" /></svg>,
    title: 'International Expansion',
    desc: 'Entry strategy, distributor networks & cross-cultural BD',
  },
  {
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="4" width="12" height="9" rx="1" /><path d="M5 4V3a1 1 0 011-1h4a1 1 0 011 1v1" /></svg>,
    title: 'Operations & Processes',
    desc: 'Efficiency, Six Sigma methodologies, cost reduction',
  },
  {
    icon: <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M8 2L2 5v6l6 3 6-3V5L8 2z" /></svg>,
    title: 'Brand & Market Positioning',
    desc: 'Value propositions, customer development & branding',
  },
];

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="hero">
      <div className="hgb" />
      <div className="hgl" />
      <div className="hgl2" />
      <div className="hi">
        <div>
          <div className="hbdg rv">
            <div className="hbdg-dot" />
            <span>Corporate Strategy &amp; Business Development</span>
          </div>
          <h1 className="ht rv d1">
            Your Growth<br /><span className="lg">Begins Here.</span>
          </h1>
          <p className="hs rv d2">
            StratX helps ambitious companies penetrate new markets, optimize operations, and build sustainable growth across India, the Middle East, and Africa.
          </p>
          <div className="ha rv d3">
            <button className="bp" onClick={() => scrollTo('contact')}>
              Book Strategy Consultation <ArrowIcon />
            </button>
            <button className="bo" onClick={() => scrollTo('cases')}>
              View Case Studies
            </button>
          </div>
        </div>
        <div className="hp rv d2">
          <div className="hpt">Core Capabilities</div>
          {capabilities.map((cap) => (
            <div className="hpi" key={cap.title}>
              <div className="hpic">{cap.icon}</div>
              <div className="hpitx">
                <strong>{cap.title}</strong>
                {cap.desc}
              </div>
            </div>
          ))}
          <div className="hrg">
            <div className="hrgl">Coverage</div>
            <div className="hrgls">
              {['India', 'UAE / Dubai', 'Middle East', 'Africa'].map((tag) => (
                <span className="rtag" key={tag}>{tag}</span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
